export const toWords = (value) => value
  .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
  .toLowerCase()
  .split(/[^a-z0-9+]+/)
  .filter((word) => word !== '');

const haystackFor = (name, keywords) => [name.toLowerCase(), ...toWords(name), ...toWords(keywords)];

// Matching on word prefixes rather than substrings is what keeps 'ok' on 👍
// instead of also returning book, cook and look.
export const iconMatchesQuery = (name, query, keywords = '') => {
  const tokens = toWords(query);
  if (tokens.length === 0) {
    return query.trim() === '';
  }

  const haystack = haystackFor(name, keywords);
  return tokens.every((token) => haystack.some((word) => word.startsWith(token)));
};
